// extracted by mini-css-extract-plugin
export default {"textContainer":"TextWithTooltip_textContainer__iV7DF","truncatedText":"TextWithTooltip_truncatedText__2PQPE","tooltip":"TextWithTooltip_tooltip__1msnI"};